module.exports = "/next-static/_next/static/images/block_image_multiple_platforms-02268799783b3a16e2c436fb4c38ab1d.webp";